export const environment = {
  production: true,
  apiUrl: "https://api.mylingotrip.com",
  leadDynoPrivateKey: '165d71696287208d956a45cffb6d8112b66f0e81',
  isChatEnabled: false,
  firebase: {
    apiKey: "AIzaSyAS3J9uI0k2gtFBSI1daBcG2xbWJrBcCik",
    authDomain: "mylingotrip-d2338.firebaseapp.com",
    projectId: "mylingotrip-d2338",
    storageBucket: "mylingotrip-d2338.appspot.com",
    messagingSenderId: "618062748166",
    appId: "1:618062748166:web:83fa6d423e3d6913db0187",
    measurementId: "G-QF0X9YTHTL"
  }
};
